var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Image } from '../../Image';
import Skeleton, { withSkeleton } from '../../Skeleton';
var SkeletonStyled = styled(Skeleton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));
var ImageSkeleton = function (_a) {
    var _b = _a.animation, animation = _b === void 0 ? true : _b;
    return (React.createElement(SkeletonStyled, { animation: animation, height: "100%" }));
};
var ProductImage = function (_a) {
    // TODO: Change fallback image to actual image or variable
    var imageOrientation = _a.imageOrientation, _b = _a.imageUrl, imageUrl = _b === void 0 ? '' : _b, isVisible = _a.isVisible, name = _a.name;
    return isVisible ? (React.createElement(Image, { alt: name, src: imageUrl + "/?$PL_" + imageOrientation + "_hq$", title: name, loadingComponent: function () { return React.createElement(ImageSkeleton, null); }, keepPrevLoadedImage: true, fallback: function () { return React.createElement(ImageSkeleton, { animation: false }); } })) : (React.createElement(ImageSkeleton, null));
};
export default withSkeleton(ProductImage, function () { return React.createElement(ImageSkeleton, null); });
var templateObject_1;
//# sourceMappingURL=index.js.map